import React from "react";
import {Navigate} from "react-router-dom";

function RequireAuth({children, redirectTo}) {
  let isAuthenticated = (sessionStorage.getItem("token") !== null);
  return isAuthenticated ? children : <Navigate to={redirectTo}/>;
}

export default RequireAuth;
